<div class="podium">
    <div class="podium__item podium__second">
        <h3>{{ topSkills[1]?.skill.name }}</h3>
        <p>{{ topSkills[1]?.score }}%</p>
        <img src="/assets/utils/medalla-plata.png" alt="Segundo lugar" />
        <div class="podium__column podium__column--second"></div>
    </div>

    <div class="podium__item podium__first">
        <h2>{{ topSkills[0]?.skill.name }}</h2>
        <p>{{ topSkills[0]?.score }}%</p>
        <img src="/assets/utils/medalla-oro.png" alt="Primer lugar" />
        <div class="podium__column podium__column--first"></div>
    </div>

    <div class="podium__item podium__third">
        <h3>{{ topSkills[2]?.skill.name }}</h3>
        <p>{{ topSkills[2]?.score }}%</p>
        <img src="/assets/utils/medalla-bronce.png" alt="Tercer lugar" />
        <div class="podium__column podium__column--third"></div>
    </div>
</div>